import { SettingOutlined } from "@ant-design/icons"
import cx from "clsx"
import { Icon, notification, Skeleton, Space, Text, Title } from "components/common"
import useWhatsappSocket from "hooks/useWhatsppSocket"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import theme from "utils/themeVars"
import styles from "../index.module.less"
import { setIsLoggedIn } from "store/appSlice"
import parentApi from "store/parentApi"
import { setStorageItem } from "utils/localStorage"
import { LOGIN_STORAGE_KEY } from "constants"

const WhatsappQRCode = user => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [unblockOnWhatsappQR] = parentApi.useUnblockOnWhatsappQRMutation()
  const { qrCode, isLinked } = useWhatsappSocket(user?.user?.cell)
  useEffect(() => {
    if (isLinked) {
      unblockOnWhatsappQR({ userId: user?.user?.id, isVerified: true })
        .unwrap()
        .then(() => {
          notification.success({ message: "WhatsApp connected successfully" })
          dispatch(setIsLoggedIn(true))
          setStorageItem(LOGIN_STORAGE_KEY, "yes")
        }).catch((error)=>{
         notification.error({ message: error?.message})
        })
    }
  }, [isLinked])
  return (
    <Space direction="vertical" size={16} className="text-center w-100">
      <Icon style={{ color: theme["primary-color"] }} icon="RiWhatsappFill" size="40px" />
      <Title level={1}>{t("Connect WhatsApp")}</Title>
      <div className={styles.instructionContainer}>
        <Text type="secondary">{t("Please follow the steps below to connect your WhatsApp:")}</Text>
        <Space direction="vertical" size={16} className="pb-16">
          <ol className={cx(styles.lists, "gray-900 mbe-0")}>
            <li>
              <Text>
                {t("Open WhatsApp on your phone")
                  .split("WhatsApp")
                  .map((part, index) => 
                    index === 0 ? part : (
                      <span key={index}>
                        <strong>WhatsApp</strong>
                        <Icon style={{ color: theme["primary-color"], marginInlineStart: "4px", marginInlineEnd: "4px", verticalAlign: "middle" }} icon="RiWhatsappFill" size="20px" />
                        {part}
                      </span>
                    )
                  )}
              </Text>
            </li>
            <li>
              <Text>
                {t("On Android tap Menu. On iPhone tap Settings")
                  .split(/(\bMenu\b|\bSettings\b)/)
                  .map((part, index) => {
                    if (part === "Menu") {
                      return (
                        <span key={index}>
                          <strong>{t("Menu")}</strong>
                          <Icon icon="FiMoreVertical" size="20px" style={{ marginInlineStart: "4px", marginInlineEnd: "4px", verticalAlign: "middle" }} />
                        </span>
                      )
                    } else if (part === "Settings") {
                      return (
                        <span key={index}>
                          <strong>{t("Settings")}</strong>
                          <SettingOutlined style={{ marginInlineStart: "4px", verticalAlign: "middle" }} />
                        </span>
                      )
                    }
                    return part
                  })}
              </Text>
            </li>
            <li>
              <Text>
                {t("Tap Linked devices, then Link device")
                  .split(/(\bLinked devices\b|\bLink device\b)/)
                  .map((part, index) => {
                    if (part === "Linked devices") {
                      return <strong key={index}>{t("Linked devices")}</strong>
                    } else if (part === "Link device") {
                      return <strong key={index}>{t("Link device")}</strong>
                    }
                    return part
                  })}
              </Text>
            </li>
            <li>
              <Text>{t("Scan the QR code to confirm")}</Text>
            </li>
          </ol>
        </Space>
      </div>
      {!qrCode ? <Skeleton type="image" style={{ width: 200, height: 200 }} active /> : <img src={qrCode || null} alt={t("QR Code")} style={{ width: 200, height: 200 }} /> }      
    </Space>
  )
}

export default WhatsappQRCode
